/* global debounce, trapFocus */

if (!customElements.get('cart-items')) {
  class CartItems extends HTMLElement {
    constructor() {
      super();
      if (this.dataset.empty === 'false') this.init();
    }

    init() {
      this.querySelectorAll('.cart-item__remove').forEach(e => e.addEventListener('click', (evt) => { evt.preventDefault(); this.handleClick(evt.target.getAttribute('data-key'),evt.target.getAttribute('data-id'),evt.target.getAttribute('data-product-id')) }));
    }

    handleCartItemChange(key, variantId, productId, quantity) {
      this.updateQuantity(key, variantId, productId, quantity);
    }

    /**
     * Handles 'click' events on the cart items element.
     * @param {object} evt - Event object.
     */
    handleClick(key, variantId, productId) {
      // if (!evt.target.matches('.js-remove-item')) return;
      // evt.preventDefault();
      this.updateQuantity(key, variantId, productId, 0);
    }

    /**
     * Updates the quantity of a line item.
     * @param {string} key - Line item key.
     * @param {string} variantId - Line item variantId.
     * @param {string} productId - Line item productId.
     * @param {number} quantity - Quantity to set.
     */
    async updateQuantity(key, variantId, productId, quantity) {

      const item = JSON.parse(document.querySelector(`[data-item="${key}"]`)?.innerText);
      this.enableLoading();

      if (quantity > 0) {
        this.enableLoading();
      } else {
        this.querySelector(`.cart-item[data-line-item-key="${key}"]`).nextElementSibling.remove();
        this.querySelector(`.cart-item[data-line-item-key="${key}"]`).remove();
      }

      const checkoutId = localStorage.getItem('checkoutId');

      try {

        const before_updated_cart = LocalCart.getState();
        const before_updated_sub_total = before_updated_cart.total_price;

        LocalCart.updateQuantity(variantId, quantity);

        const updated_cart = LocalCart.getState();
        const updated_sub_total = updated_cart.total_price;

        // Local cart update event so latest cart saved to metafield
        if(sharedCart && Object.keys(sharedCart).length){
          await sharedCart.handleCartChange();
        }

        //Update the quantity-input value for this variant inside a kios cached
        if (AssortmentCache) await AssortmentCache.patchCartQty(String(productId), String(variantId), Number(quantity), key).catch(() => {});
        //refresh the assortment page if is open
        localStorage.setItem('tab_refresh_trigger', Date.now().toString());

        // remove shipping cost local storage if cart is empty.
        if(updated_cart.item_count <= 0) localStorage.removeItem('checkout_shipping');

        // Remove shipping cost from localStorage to fetch the latest rate when the cart is updated,
        // only if the free shipping threshold has been reached
        if(updated_cart.item_count > 0){
          const cartElement = document.querySelector(`cart-checkout`);
          //shipping logic;
          const shippingFreeThreshold = Number(cartElement?.shippingFreeThreshold || 30000)/100;
          if(((before_updated_sub_total/100) < shippingFreeThreshold && (updated_sub_total/100) >= shippingFreeThreshold || (before_updated_sub_total/100) > shippingFreeThreshold && (updated_sub_total/100) <= shippingFreeThreshold)){
            localStorage.removeItem('checkout_shipping');
          }
          //bonus logic;
          await cartElement?.updateSubmitedBonus();
        }

        await this.refreshCartItems();

      } catch (error) {
        console.error('❌ Error updating cart item:', error);
        // Re-enable UI on error
        if (window.checkout) {
          window.checkout.loading = false;
        }
        throw error;
      }
    }

    /**
     * Refresh cart items section
     * Called from other components like product-form and cart-drawer
     */
    async refreshCartItems() {
      console.log('🔄 Refreshing cart items...');
      
      // If we're on the cart page, use the checkout render method
      if (window.location.pathname.includes(`/cart`) && window.checkout && window.checkout.render) {
        await window.checkout.render();
      } else {
        // Otherwise use the global render function
        window.location.reload();
      }
    }

    /**
     * Gets the innerHTML of an element.
     * @param {string} html - Section HTML.
     * @param {string} selector - CSS selector for the element to get the innerHTML of.
     * @returns {string}
     */
    static getElementHTML(html, selector) {
      const tmpl = document.createElement('template');
      tmpl.innerHTML = html;

      const el = tmpl.content.querySelector(selector);
      return el ? el.innerHTML : '';
    }

    /**
     * Shows a loading icon over a line item.
     * @param {string} line - Line item index.
     */
    enableLoading() {
      window.checkout.loading = true;
      document.activeElement.blur();
    }
  }

  customElements.define('cart-items', CartItems);
}
